/**
 * Positions from Figma map_screen (55:2), design size 1080×1920.
 *
 * left/right live inside `.map-arrows` (map strip); `top: 0` + CSS
 * vertical centering keep them aligned with side arrows.
 *
 * left_deliveries_count  (55:1045) → left 34, 61.439×61.439
 * right_deliveries_count (55:1035) → left 985, 61.439×61.439
 * top_deliveries_count   (55:1050) → 575 × 227, 61.439×61.439
 * down_deliveries_count  (55:1060) → 460.998 × 1542, 61.439×61.439
 *
 * Note: hint_icon.svg is 72×72 (circle + stroke overflow).
 * Frame size below is the Figma node bounds (fill circle without stroke).
 */
export const DELIVERY_HINT_SIZE = {
  width: 61.439,
  height: 61.439,
} as const;

export const DELIVERY_HINT_POSITIONS = {
  left: { left: 34, top: 0 },
  right: { left: 985, top: 0 },
  top: { left: 575, top: 227 },
  down: { left: 460.998, top: 1542 },
} as const;

export type DeliveryHintDirection = keyof typeof DELIVERY_HINT_POSITIONS;
